// engine
import { ArController, assetsService, gameDispatcher, soundService } from '@aceroll/core';


// hacksaw
import { responseService } from '@aceroll/platform-hacksaw';

import { platform } from '../../platform';

// library
import { slotDispatcher } from '@aceroll/core/library';

// services
import { gameSoundService } from '../../services/game-sound-service';

export class Loading extends ArController {
	constructor() {
		super();

		this.onProgress = this.onProgress.bind(this);
	}

	async onStart() {
		this.context.setLayout('Loading');

		await assetsService.loadStage(1, this.onProgress);

		const soundOn = localStorage.getItem('soundOn');
		const musicOn = localStorage.getItem('musicOn');

		if (soundOn === 'false') {
			soundService.mute(true);
		}

		if (musicOn === 'false') {
			soundService.muteMusic(true);
		}

		platform.setGameLoaded();

		platform.onceGameStarted().then((data) => {
			gameSoundService.initBetData(data.betLevelIndex, data.betLevels.length);

			switch (data.jurisdiction) {
				case 'ontario':
				case 'toronto':
				case 'uk':
					gameDispatcher.state.jurisdictionConfig.cheapSounds = true;
					break;
			}

			// DEBUG PURPOSES ONLY
			// gameDispatcher.state.jurisdictionConfig.cheapSounds = true;
			responseService.updateStartServerData(data);
			slotDispatcher.setReelSets(data.gameInfoData.reelSets);
			this.stop();
		});
	}

	onStop() {
		this.context.currentLayout.destroy();
	}

	onProgress(val) {
		this.context.currentLayout.loadingBar.setProgress(~~(val * 100));
	}
}
